/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'
import {Block} from 'baseui/block'

const RowBlock = ({children}) => {
  return (
    <Block
      overrides={{
        Block: {
          style: ({$theme}) => ({
            marginTop: 'none',
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingLeft: $theme.sizing.scale500,
            paddingRight: $theme.sizing.scale500,
            width: `calc(100% - ${$theme.sizing.scale800})`,
            position: 'relative',
            overflow: 'hidden',
            // zIndex: 1,
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'baseline',
            [$theme.media.medium]: {
              marginTop: 'none',
              overflow: 'hidden',
            },
            [$theme.media.large]: {
              paddingLeft: $theme.sizing.scale800,
              paddingRight: $theme.sizing.scale800,
              width: `calc(100% - ${$theme.sizing.scale1200})`,
            },
          }),
        },
      }}
    >
      {children}
    </Block>
  )
}

export default RowBlock
